import type { CasesBreachedSummary } from '@compass/client/types/cases_analytics';
import { AlertTriangle, ClipboardCheck } from 'lucide-react';
import React from 'react';

import { KpiCard } from '@/pages/analytics/components/KpiCard';
import { formatInt } from '@/pages/analytics/utils/formatters';

import { formatDurationHm } from '../utils/formatDuration';

interface BreachedSummaryStripProps {
  summary?: CasesBreachedSummary;
  breachedCases: number;
  loading?: boolean;
}

/** Shown when the SLA status filter is "SLA Breached". */
export const BreachedSummaryStrip: React.FC<BreachedSummaryStripProps> = ({
  summary,
  breachedCases,
  loading,
}) => (
  <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
    <KpiCard
      layout="horizontal"
      icon={AlertTriangle}
      iconClassName="bg-attention text-attention-foreground"
      label="Avg Time Past SLA"
      value={formatDurationHm(summary?.avg_seconds_past_sla)}
      loading={loading}
    />
    <KpiCard
      layout="horizontal"
      icon={ClipboardCheck}
      iconClassName="bg-primary/10 text-primary"
      label="Submitted Late"
      value={formatInt(breachedCases)}
      loading={loading}
    />
    <KpiCard
      layout="horizontal"
      icon={AlertTriangle}
      iconClassName="bg-critical text-critical-foreground"
      label="Longest Time to Submit"
      value={formatDurationHm(summary?.longest_submit_seconds)}
      loading={loading}
    />
  </div>
);
